module.exports = __webpack_public_path__ + "img/jian03.4f83c885.png";